var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getActiveDiagram } from '../theme';
import { centerTextX } from './measure';
/** FNV-1a style seed from branch names (stable across rebuilds). */
export function hashOrgBranchSeed(names) {
    var e_1, _a;
    var h = 2166136261;
    try {
        for (var names_1 = __values(names), names_1_1 = names_1.next(); !names_1_1.done; names_1_1 = names_1.next()) {
            var name_1 = names_1_1.value;
            for (var i = 0; i < name_1.length; i++) {
                h ^= name_1.charCodeAt(i);
                h = Math.imul(h, 16777619);
            }
            h ^= 124;
            h = Math.imul(h, 16777619);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (names_1_1 && !names_1_1.done && (_a = names_1.return)) _a.call(names_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return (h ^ (names.length * 2654435761)) >>> 0;
}
function mulberry32(seed) {
    var a = seed >>> 0 || 1;
    return function () {
        a = (a + 0x6d2b79f5) >>> 0;
        var t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
function hslToHex(h, sPct, lPct) {
    var _a, _b, _c, _d, _e, _f;
    var s = Math.max(0, Math.min(100, sPct)) / 100;
    var l = Math.max(0, Math.min(100, lPct)) / 100;
    var hue = ((h % 360) + 360) % 360;
    var c = (1 - Math.abs(2 * l - 1)) * s;
    var x = c * (1 - Math.abs(((hue / 60) % 2) - 1));
    var m = l - c / 2;
    var r = 0;
    var g = 0;
    var b = 0;
    if (hue < 60)
        _a = __read([c, x, 0], 3), r = _a[0], g = _a[1], b = _a[2];
    else if (hue < 120)
        _b = __read([x, c, 0], 3), r = _b[0], g = _b[1], b = _b[2];
    else if (hue < 180)
        _c = __read([0, c, x], 3), r = _c[0], g = _c[1], b = _c[2];
    else if (hue < 240)
        _d = __read([0, x, c], 3), r = _d[0], g = _d[1], b = _d[2];
    else if (hue < 300)
        _e = __read([x, 0, c], 3), r = _e[0], g = _e[1], b = _e[2];
    else
        _f = __read([c, 0, x], 3), r = _f[0], g = _f[1], b = _f[2];
    var to = function (v) {
        return Math.round((v + m) * 255)
            .toString(16)
            .padStart(2, '0');
    };
    return "#".concat(to(r)).concat(to(g)).concat(to(b));
}
/**
 * Build N unique branch colors (no repeats).
 * Hues are spaced on the wheel then shuffled with a seeded RNG so assignment
 * feels random but stays stable for the same seed / rebuild.
 */
export function buildDistinctOrgBranchPalette(count, seed) {
    var _a, _b;
    if (seed === void 0) { seed = 1; }
    var n = Math.max(0, Math.floor(count));
    if (n <= 0)
        return [];
    var base = getActiveDiagram().orgBranchPalette;
    // Prefer curated theme swatches first (still unique), then generate more
    if (n <= base.length) {
        var rand_1 = mulberry32(seed);
        var idxs = Array.from({ length: base.length }, function (_, i) { return i; });
        for (var i = idxs.length - 1; i > 0; i--) {
            var j = Math.floor(rand_1() * (i + 1));
            _a = __read([idxs[j], idxs[i]], 2), idxs[i] = _a[0], idxs[j] = _a[1];
        }
        return idxs.slice(0, n).map(function (i) { return (__assign({}, base[i])); });
    }
    var rand = mulberry32(seed);
    var GOLDEN = 137.508;
    var start = rand() * 360;
    var hues = Array.from({ length: n }, function (_, i) { return (start + i * GOLDEN) % 360; });
    for (var i = hues.length - 1; i > 0; i--) {
        var j = Math.floor(rand() * (i + 1));
        _b = __read([hues[j], hues[i]], 2), hues[i] = _b[0], hues[j] = _b[1];
    }
    return hues.map(function (h, i) {
        // Slight sat/light jitter so neighboring hues still read distinct on dark cards
        var satJitter = 4 * (i % 3);
        var lightJitter = 2 * (i % 2);
        return {
            fill: hslToHex(h, 42 + satJitter, 13 + lightJitter),
            stroke: hslToHex(h, 68 + satJitter, 52 + lightJitter),
            accent: hslToHex(h, 74 + satJitter, 66 + lightJitter),
        };
    });
}
/** Resolve executive vs branch/sub-branch grouping colors. */
export function resolveOrgBranchStyle(depth, branchIndex, branchPalette) {
    var _a, _b, _c;
    var d = getActiveDiagram();
    if (depth <= 0 || branchIndex == null || branchIndex < 0) {
        return __assign({}, d.orgTier[0]);
    }
    var palette = branchPalette && branchPalette.length > 0
        ? branchPalette
        : d.orgBranchPalette;
    // Palette is built per chart with unique entries — never modulo-cycle
    var base = (_a = palette[Math.min(branchIndex, palette.length - 1)]) !== null && _a !== void 0 ? _a : palette[0];
    if (depth === 1)
        return __assign({}, base);
    return {
        fill: (_c = (_b = d.orgTier[Math.min(depth, d.orgTier.length - 1)]) === null || _b === void 0 ? void 0 : _b.fill) !== null && _c !== void 0 ? _c : base.fill,
        stroke: base.stroke,
        accent: base.accent,
    };
}
/** Count every org node under `node` (all descendants, not just direct children). */
export function countOrgDescendants(node) {
    var e_2, _a;
    var _b;
    var total = 0;
    try {
        for (var _c = __values(node.children), _d = _c.next(); !_d.done; _d = _c.next()) {
            var child = _d.value;
            if (!((_b = child.metadata) === null || _b === void 0 ? void 0 : _b.orgNode))
                continue;
            total += 1 + countOrgDescendants(child);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return total;
}
/** Draw professional minimize (−) / maximize (+) control; shows total subtree size. */
export function drawOrgCollapseGlyph(app, btn, collapsed, count) {
    var e_3, _a;
    var style = collapsed
        ? getActiveDiagram().orgToggleCollapsed
        : getActiveDiagram().orgToggleExpanded;
    try {
        for (var _b = __values(__spreadArray([], __read(btn.children), false)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            btn.remove(child);
            child.destroy();
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
    var n = Math.max(0, Math.floor(count));
    var shown = n > 99 ? '99' : String(n);
    var label = collapsed ? "+".concat(shown) : "\u2212".concat(shown);
    var height = 20;
    var width = n > 9 ? 30 : 24;
    btn.metadata.orgCollapseCount = n;
    btn.add(app.roundedRect({
        x: 0,
        y: 0,
        width: width,
        height: height,
        cornerRadius: 6,
        fill: style.fill,
        stroke: style.stroke,
        strokeWidth: 1.4,
        listening: true,
    }));
    btn.add(app.roundedRect({
        x: 1,
        y: 1,
        width: width - 2,
        height: height - 2,
        cornerRadius: 5,
        fill: null,
        stroke: 'rgba(255,255,255,0.12)',
        strokeWidth: 1,
        listening: false,
    }));
    btn.add(app.text({
        text: label,
        x: n > 9 ? 3 : 4.5,
        y: 3.5,
        fontSize: n > 9 ? 9 : 10,
        fontWeight: '700',
        fontFamily: getActiveDiagram().fontFamily,
        fill: style.glyph,
        listening: false,
    }));
}
/** Refresh minimize/maximize button after toggle (count = total descendants). */
export function updateOrgCollapseButton(node, collapsed) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var btn = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a.collapseButton;
    var app = node.getApp();
    if (!btn || !app)
        return;
    var live = countOrgDescendants(node);
    var count = live > 0
        ? live
        : typeof ((_b = node.metadata) === null || _b === void 0 ? void 0 : _b.descendantCount) === 'number'
            ? node.metadata.descendantCount
            : ((_d = (_c = node.metadata) === null || _c === void 0 ? void 0 : _c.childCount) !== null && _d !== void 0 ? _d : 0);
    node.metadata.descendantCount = count;
    // Keep button flush to the card corner as width changes with digit count
    var cardW = (_f = (_e = node.metadata) === null || _e === void 0 ? void 0 : _e.orgCardWidth) !== null && _f !== void 0 ? _f : 138;
    var cardH = (_h = (_g = node.metadata) === null || _g === void 0 ? void 0 : _g.orgCardHeight) !== null && _h !== void 0 ? _h : 0;
    var btnW = count > 9 ? 30 : 24;
    btn.x = cardW - btnW - 6;
    if (cardH > 0)
        btn.y = cardH - 26;
    drawOrgCollapseGlyph(app, btn, collapsed, count);
}
/** Build a circular SVG avatar data-URI from initials (offline-safe fallback). */
export function orgInitialsAvatarDataUri(name, accent, fill) {
    if (fill === void 0) { fill = '#1e293b'; }
    var initials = name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map(function (p) { var _a, _b; return (_b = (_a = p[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== null && _b !== void 0 ? _b : ''; })
        .join('') || '?';
    var svg = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"128\" height=\"128\" viewBox=\"0 0 128 128\">" +
        "<rect width=\"128\" height=\"128\" fill=\"".concat(fill, "\"/>") +
        "<circle cx=\"64\" cy=\"64\" r=\"60\" fill=\"".concat(accent, "\" opacity=\"0.22\"/>") +
        "<text x=\"64\" y=\"74\" text-anchor=\"middle\" font-family=\"Segoe UI, Inter, system-ui, sans-serif\" " +
        "font-size=\"42\" font-weight=\"700\" fill=\"".concat(accent, "\">").concat(initials, "</text></svg>");
    return "data:image/svg+xml;charset=utf-8,".concat(encodeURIComponent(svg));
}
/** Professional portrait org-chart card with optional photo. */
export function createOrgNode(app, nameOrOpts, role, childCount, collapsed, depth) {
    if (childCount === void 0) { childCount = 0; }
    if (collapsed === void 0) { collapsed = false; }
    if (depth === void 0) { depth = 0; }
    var opts = typeof nameOrOpts === 'string'
        ? { name: nameOrOpts, role: role, childCount: childCount, collapsed: collapsed, depth: depth }
        : __assign({ childCount: 0, collapsed: false, depth: 0 }, nameOrOpts);
    var name = opts.name, title = opts.role, image = opts.image, department = opts.department, _a = opts.childCount, kids = _a === void 0 ? 0 : _a, _b = opts.collapsed, isCollapsed = _b === void 0 ? false : _b, _c = opts.depth, level = _c === void 0 ? 0 : _c, branchStyle = opts.branchStyle;
    var tier = branchStyle !== null && branchStyle !== void 0 ? branchStyle : getActiveDiagram().orgTier[Math.min(level, getActiveDiagram().orgTier.length - 1)];
    var hasDept = Boolean(department);
    var width = 138;
    var photoR = 26;
    var photoTop = 14;
    var textStartY = photoTop + photoR * 2 + 10;
    var height = textStartY + (title ? 18 : 0) + (hasDept ? 14 : 0) + 18;
    var node = app.group();
    node.metadata.orgCardWidth = width;
    node.metadata.orgCardHeight = height;
    node.metadata.orgBranchStroke = tier.stroke;
    node.metadata.orgBranchAccent = tier.accent;
    node.add(app.roundedRect({
        width: width,
        height: height,
        cornerRadius: 10,
        fill: tier.fill,
        stroke: tier.stroke,
        strokeWidth: 1.5,
        shadow: getActiveDiagram().orgCardShadow,
        listening: false,
    }));
    // Branch accent bar (grouping cue)
    node.add(app.rect({
        x: 0,
        y: 0,
        width: width,
        height: 3,
        fill: tier.accent,
        stroke: null,
        listening: false,
    }));
    node.add(app.roundedRect({
        x: 1,
        y: 1,
        width: width - 2,
        height: height - 2,
        cornerRadius: 9,
        fill: null,
        stroke: 'rgba(255,255,255,0.06)',
        strokeWidth: 1,
        listening: false,
    }));
    var photoX = (width - photoR * 2) / 2;
    var photoSrc = (image === null || image === void 0 ? void 0 : image.trim()) || orgInitialsAvatarDataUri(name, tier.accent, tier.fill);
    var mask = app.circle({ radius: photoR });
    node.add(app.image({
        src: photoSrc,
        x: photoX,
        y: photoTop,
        width: photoR * 2,
        height: photoR * 2,
        mask: mask,
        listening: false,
    }));
    node.add(app.circle({
        x: photoX,
        y: photoTop,
        radius: photoR,
        fill: null,
        stroke: tier.accent,
        strokeWidth: 2,
        listening: false,
    }));
    var ty = textStartY;
    var nameFs = getActiveDiagram().fontSize.base;
    node.add(app.text({
        text: name,
        x: centerTextX(name, width, nameFs, '700'),
        y: ty,
        fontSize: nameFs,
        fontWeight: '700',
        fontFamily: getActiveDiagram().fontFamily,
        fill: getActiveDiagram().nodeText,
        listening: false,
    }));
    ty += 16;
    if (title) {
        var roleFs = getActiveDiagram().fontSize.sm;
        node.add(app.text({
            text: title,
            x: centerTextX(title, width, roleFs, '500'),
            y: ty,
            fontSize: roleFs,
            fontWeight: '500',
            fontFamily: getActiveDiagram().fontFamily,
            fill: getActiveDiagram().orgRole,
            listening: false,
        }));
        ty += 14;
    }
    if (department) {
        var deptFs = getActiveDiagram().fontSize.xs;
        node.add(app.text({
            text: department,
            x: centerTextX(department, width, deptFs, '500'),
            y: ty,
            fontSize: deptFs,
            fontWeight: '500',
            fontFamily: getActiveDiagram().fontFamily,
            fill: getActiveDiagram().nodeTextMuted,
            listening: false,
        }));
    }
    node.add(app.circle({
        x: width / 2 - 3.5,
        y: height - 3.5,
        radius: 3.5,
        fill: tier.accent,
        stroke: getActiveDiagram().surface,
        strokeWidth: 1.25,
        listening: false,
    }));
    var indicator;
    if (kids > 0) {
        var btnW = kids > 9 ? 30 : 24;
        var bx = width - btnW - 6;
        var by = height - 26;
        var btn = app.group({
            x: bx,
            y: by,
            listening: true,
            zIndex: 20,
        });
        btn.metadata.orgCollapseBtn = true;
        drawOrgCollapseGlyph(app, btn, isCollapsed, kids);
        node.add(btn);
        node.metadata.collapseButton = btn;
        indicator = btn;
    }
    return { node: node, indicator: indicator };
}
